/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Spaces_Floating_Comparing_WithInputs */



/**
* | output |
* | --- |
* | "Comparing with {name}" |
*
* @param {Spaces_Floating_Comparing_WithInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_floating_comparing_with = /** @type {((inputs: Spaces_Floating_Comparing_WithInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Floating_Comparing_WithInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Vergleich mit ${i?.name}`)
	return /** @type {LocalizedString} */ (`Comparing with ${i?.name}`)
});